<template>
  <div
    v-if="avatar"
    class="
      w-full
      bg-cover bg-center
      flex flex-col
      items-center
      justify-center
      h-full
    "
  >
    <img
      v-if="mediaType == 1"
      :class="[templateId == 1 ? 'h-64' : 'h-full']"
      class="w-full object-cover"
      :src="avatar"
      alt=""
    />
    <iframe
      :class="[templateId == 1 ? 'h-80' : '']"
      class="w-full object-cover"
      v-else
      :src="video"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'Avatar',
  props: {
    templateId: {},
    avatar: {},
    mediaType: {},
    video: {},
  },
};
</script>